<script setup lang="ts">
import Dialog from 'primevue/dialog';
import { computed, shallowRef } from 'vue';

import Badge from 'lib/components/badge/Badge.vue';
import type { BadgeGroupProps } from 'lib/components/badgegroup/BadgeGroup.vue.d';
import Button from 'lib/components/button/Button.vue';

const props = withDefaults(defineProps<BadgeGroupProps>(), {
  headerLabel: 'Header',
  textMore: 'more',
  textMoreSeverity: undefined,
});

const detailDialog = shallowRef(false);

const showedLabels = computed(() => {
  return props.labels.slice(0, props.limit); // When limit undefined, it will return full array
});

const totalRemainingLabel = computed(
  () => props.labels.length - showedLabels.value.length,
);
</script>

<template>
  <div v-if="showedLabels.length" v-bind="$preset.badgegroup.root">
    <Badge
      :key="typeof label === 'string' ? label : label.text"
      v-for="label in showedLabels"
      :format="props.format"
      :label="typeof label === 'string' ? label : label.text"
      :severity="typeof label === 'string' ? props.severity : label.severity"
      :tooltip="typeof label === 'object' && label.tooltip"
    />

    <Button
      v-if="totalRemainingLabel"
      :label="`+${totalRemainingLabel} ${textMore}`"
      v-bind="$preset.badgegroup.showmorebutton"
      :severity="props.textMoreSeverity ?? 'dark'"
      @click="detailDialog = true"
      text
    />

    <Dialog
      v-if="limit"
      v-model:visible="detailDialog"
      :draggable="false"
      :header="headerLabel"
      :pt="$preset.badgegroup.showmoredialog"
      modal
    >
      <slot :labels="props.labels" name="dialogcontent">
        <Badge
          :key="typeof label === 'string' ? label : label.text"
          v-for="label in props.labels"
          :format="props.format"
          :label="typeof label === 'string' ? label : label.text"
          :severity="
            typeof label === 'string' ? props.severity : label.severity
          "
          :tooltip="typeof label === 'object' && label.tooltip"
        />
      </slot>
    </Dialog>
  </div>

  <span v-else> - </span>
</template>
